import { MailOutlined } from "@ant-design/icons";
import { Input, message } from "antd";
import Button from "../../../components/generic/Button";
import { useCallback, useEffect, useState } from "react";
import httpClient from "../../../api/httpClient";

const VerifyOtp = (props) => {
  const { userEmail, setStep } = props;
  const [timer, setTimer] = useState(60);
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleResendOtp = useCallback(async () => {
    try {
      setLoading(true);

      await httpClient.publicPost("resend-otp", { email: userEmail });

      setTimer(60);

      setOtp("");

      message.success("OTP resent successfully!");
    } catch (error) {
      message.error(
        //@ts-ignore
        error?.errorMessage || "Failed to resend OTP. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  }, [userEmail, otp]);

  const handleVerifyOtp = useCallback(async () => {
    try {
      setLoading(true);

      await httpClient.publicPost("verify-otp", {
        email: userEmail,
        code: otp,
      });

      setStep("success");

      message.success("Account verified successfully!");
    } catch (error) {
      message.error(
        //@ts-ignore
        error?.errorMessage || "Failed to resend OTP. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  }, [userEmail, otp]);

  return (
    <div className="flex-col align-center otp-container">
      <div className="flex-center bg-primary rounded otp-icon">
        <MailOutlined />
      </div>
      <h2 className="otp-title">Verify Your Email</h2>
      <p className="text-gray otp-subtitle">
        We've sent a verification code to
        <br />
        <span className="text-primary otp-email">{userEmail}</span>
      </p>

      <div className="otp-input-wrapper">
        <Input.OTP onChange={setOtp} type="tel" />
      </div>

      <div className="otp-timer">
        {timer > 0 ? (
          <>
            Resend code in <span className="timer-text">{timer}s</span>
          </>
        ) : (
          <Button
            size="small"
            type="link"
            className="text-primary"
            disabled={!!timer}
            loading={loading}
            onClick={handleResendOtp}
          >
            Resend OTP
          </Button>
        )}
      </div>
      <Button
        type="primary"
        className="w-100"
        onClick={handleVerifyOtp}
        loading={loading}
        disabled={otp.length !== 6}
      >
        Verify Email
      </Button>
    </div>
  );
};

export default VerifyOtp;
